import DenguefeverEntrySvg from '@/client/assets/images/denguefever/entry.svg';
import DenguefeverPrizeButtonSvg from '@/client/assets/images/denguefever/luckydraw_go.svg';
import DenguefeverPrizeSpinSvg from '@/client/assets/images/denguefever/luckydraw_spin.svg';
import DenguefeverPrizeWheelSvg from '@/client/assets/images/denguefever/luckydraw_wheel.svg';
import DenguefeverPrizeBackgroundSvg from '@/client/assets/images/denguefever/prize_background.svg';
import DenguefeverQ1Svg from '@/client/assets/images/denguefever/q1.svg';
import DenguefeverQ2Svg from '@/client/assets/images/denguefever/q2.svg';
import DenguefeverQ3Svg from '@/client/assets/images/denguefever/q3.svg';
import DenguefeverQ4Svg from '@/client/assets/images/denguefever/q4.svg';
import DenguefeverQ5Svg from '@/client/assets/images/denguefever/q5.svg';
import DenguefeverQuizBackgroundSvg from '@/client/assets/images/denguefever/quiz-background.svg';
import EnterovirusEntrySvg from '@/client/assets/images/enterovirus/entry.svg';
import EnterovirusPrizeSpinSvg from '@/client/assets/images/enterovirus/luckydraw_spin.svg';
import EnterovirusPrizeBackgroundSvg from '@/client/assets/images/enterovirus/prize_background.svg';
import EnterovirusQ1Svg from '@/client/assets/images/enterovirus/q1.svg';
import EnterovirusQ2Svg from '@/client/assets/images/enterovirus/q2.svg';
import EnterovirusQ3Svg from '@/client/assets/images/enterovirus/q3.svg';
import EnterovirusQ4Svg from '@/client/assets/images/enterovirus/q4.svg';
import EnterovirusQ5Svg from '@/client/assets/images/enterovirus/q5.svg';
import EnterovirusQuizBackgroundSvg from '@/client/assets/images/enterovirus/quiz-background.svg';
import FluEntrySvg from '@/client/assets/images/flu/entry.svg';
import FluPrizeButtonSvg from '@/client/assets/images/flu/luckydraw_go.svg';
import FluPrizeSpinSvg from '@/client/assets/images/flu/luckydraw_spin.svg';
import FluPrizeWheelSvg from '@/client/assets/images/flu/luckydraw_wheel.svg';
import FluPrizeBackgroundSvg from '@/client/assets/images/flu/prize_background.svg';
import FluQ1Svg from '@/client/assets/images/flu/q1.svg';
import FluQ2Svg from '@/client/assets/images/flu/q2.svg';
import FluQ3Svg from '@/client/assets/images/flu/q3.svg';
import FluQ4Svg from '@/client/assets/images/flu/q4.svg';
import FluQ5Svg from '@/client/assets/images/flu/q5.svg';
import FluQuizBackgroundSvg from '@/client/assets/images/flu/quiz-background.svg';
import MeaslesEntrySvg from '@/client/assets/images/measles/entry.svg';
import MeaslesPrizeButtonSvg from '@/client/assets/images/measles/luckydraw_go.svg';
import MeaslesPrizeSpinSvg from '@/client/assets/images/measles/luckydraw_spin.svg';
import MeaslesPrizeWheelSvg from '@/client/assets/images/measles/luckydraw_wheel.svg';
import MeaslesPrizeBackgroundSvg from '@/client/assets/images/measles/prize_background.svg';
import MeaslesQ1Svg from '@/client/assets/images/measles/q1.svg';
import MeaslesQ2Svg from '@/client/assets/images/measles/q2.svg';
import MeaslesQ3Svg from '@/client/assets/images/measles/q3.svg';
import MeaslesQ4Svg from '@/client/assets/images/measles/q4.svg';
import MeaslesQ5Svg from '@/client/assets/images/measles/q5.svg';
import MeaslesQuizBackgroundSvg from '@/client/assets/images/measles/quiz-background.svg';
import NovelInfluenzaAEntrySvg from '@/client/assets/images/novel-influenza-a/entry.svg';
import NovelInfluenzaAPrizeButtonSvg from '@/client/assets/images/novel-influenza-a/luckydraw_go.svg';
import NovelInfluenzaAPrizeSpinSvg from '@/client/assets/images/novel-influenza-a/luckydraw_spin.svg';
import NovelInfluenzaAPrizeWheelSvg from '@/client/assets/images/novel-influenza-a/luckydraw_wheel.svg';
import NovelInfluenzaAPrizeBackgroundSvg from '@/client/assets/images/novel-influenza-a/prize_background.svg';
import NovelInfluenzaAQ1Svg from '@/client/assets/images/novel-influenza-a/q1.svg';
import NovelInfluenzaAQ2Svg from '@/client/assets/images/novel-influenza-a/q2.svg';
import NovelInfluenzaAQ3Svg from '@/client/assets/images/novel-influenza-a/q3.svg';
import NovelInfluenzaAQ4Svg from '@/client/assets/images/novel-influenza-a/q4.svg';
import NovelInfluenzaAQ5Svg from '@/client/assets/images/novel-influenza-a/q5.svg';
import NovelInfluenzaAQuizBackgroundSvg from '@/client/assets/images/novel-influenza-a/quiz-background.svg';
import TbEntrySvg from '@/client/assets/images/tb/entry.svg';
import PrizeButtonSvg from '@/client/assets/images/tb/luckydraw_go.svg';
import TbPrizeBackgroundSvg from '@/client/assets/images/tb/luckydraw_page.svg';
import TbPrizeSpinSvg from '@/client/assets/images/tb/luckydraw_spin.svg';
import PrizeWheelSvg from '@/client/assets/images/tb/luckydraw_wheel.svg';
import TbQ1Svg from '@/client/assets/images/tb/q1.svg';
import TbQ2Svg from '@/client/assets/images/tb/q2.svg';
import TbQ3Svg from '@/client/assets/images/tb/q3.svg';
import TbQ4Svg from '@/client/assets/images/tb/q4.svg';
import TbQ5Svg from '@/client/assets/images/tb/q5.svg';
import TbQuizBackgroundSvg from '@/client/assets/images/tb/quiz-background.svg';

export const PRIZE_STATUS = {
  // 無名額
  PRIZE_FULL: 4,
  // 已抽獎
  PRIZE_DRAWN: 3,
  // 有中獎
  PRIZE_RECEIVED: 2,
  // 未中獎
  PRIZE_MISSED: 1,
  // 未抽獎
  PRIZE_INIT: 0,
};

export const diseaseConfig = {
  tb: {
    id: 'tb',
    name: '結核病',
    totalQuestion: 5,
    partNum: 2,
    primaryColor: '#03B0D8',
    redeemDate: '112年12月10日(日)',
    entrySvg: TbEntrySvg,
    questionSvgs: [TbQ1Svg, TbQ2Svg, TbQ3Svg, TbQ4Svg, TbQ5Svg],
    quizBackground: TbQuizBackgroundSvg,
    prizeButton: PrizeButtonSvg,
    prizeBackground: TbPrizeBackgroundSvg,
    prizeSpin: TbPrizeSpinSvg,
    prizeWheel: PrizeWheelSvg,
  },
  enterovirus: {
    id: 'enterovirus',
    name: '腸病毒',
    totalQuestion: 5,
    partNum: 1,
    primaryColor: '#E05F81',
    redeemDate: '113年07月14日(日)',
    entrySvg: EnterovirusEntrySvg,
    questionSvgs: [EnterovirusQ1Svg, EnterovirusQ2Svg, EnterovirusQ3Svg, EnterovirusQ4Svg, EnterovirusQ5Svg],
    quizBackground: EnterovirusQuizBackgroundSvg,
    prizeButton: PrizeButtonSvg,
    prizeBackground: EnterovirusPrizeBackgroundSvg,
    prizeSpin: EnterovirusPrizeSpinSvg,
    prizeWheel: PrizeWheelSvg,
  },
  denguefever: {
    id: 'denguefever',
    name: '登革熱',
    totalQuestion: 5,
    partNum: 1,
    primaryColor: '#EA7154',
    redeemDate: '113/9/27(五)',
    entrySvg: DenguefeverEntrySvg,
    questionSvgs: [DenguefeverQ1Svg, DenguefeverQ2Svg, DenguefeverQ3Svg, DenguefeverQ4Svg, DenguefeverQ5Svg],
    quizBackground: DenguefeverQuizBackgroundSvg,
    prizeButton: DenguefeverPrizeButtonSvg,
    prizeBackground: DenguefeverPrizeBackgroundSvg,
    prizeSpin: DenguefeverPrizeSpinSvg,
    prizeWheel: DenguefeverPrizeWheelSvg,
  },
  flu: {
    id: 'flu',
    name: '流感',
    totalQuestion: 5,
    partNum: 1,
    primaryColor: '#ff8200',
    redeemDate: '113年11月17日(日)',
    entrySvg: FluEntrySvg,
    questionSvgs: [FluQ1Svg, FluQ2Svg, FluQ3Svg, FluQ4Svg, FluQ5Svg],
    quizBackground: FluQuizBackgroundSvg,
    prizeButton: FluPrizeButtonSvg,
    prizeBackground: FluPrizeBackgroundSvg,
    prizeSpin: FluPrizeSpinSvg,
    prizeWheel: FluPrizeWheelSvg,
  },
  'novel-influenza-a': {
    id: 'novel-influenza-a',
    name: '新型A型流感',
    totalQuestion: 5,
    partNum: 1,
    primaryColor: '#447F7C',
    redeemDate: '2024/12/27(五)',
    entrySvg: NovelInfluenzaAEntrySvg,
    questionSvgs: [
      NovelInfluenzaAQ1Svg,
      NovelInfluenzaAQ2Svg,
      NovelInfluenzaAQ3Svg,
      NovelInfluenzaAQ4Svg,
      NovelInfluenzaAQ5Svg,
    ],
    quizBackground: NovelInfluenzaAQuizBackgroundSvg,
    prizeButton: NovelInfluenzaAPrizeButtonSvg,
    prizeBackground: NovelInfluenzaAPrizeBackgroundSvg,
    prizeSpin: NovelInfluenzaAPrizeSpinSvg,
    prizeWheel: NovelInfluenzaAPrizeWheelSvg,
  },
  measles: {
    id: 'measles',
    name: '麻疹',
    totalQuestion: 5,
    partNum: 1,
    primaryColor: '#A06FC5',
    redeemDate: '2025/7/6(日)',
    entrySvg: MeaslesEntrySvg,
    questionSvgs: [MeaslesQ1Svg, MeaslesQ2Svg, MeaslesQ3Svg, MeaslesQ4Svg, MeaslesQ5Svg],
    quizBackground: MeaslesQuizBackgroundSvg,
    prizeButton: MeaslesPrizeButtonSvg,
    prizeBackground: MeaslesPrizeBackgroundSvg,
    prizeSpin: MeaslesPrizeSpinSvg,
    prizeWheel: MeaslesPrizeWheelSvg,
  },
};
